<template>
  <SecondaryButton class="w-full flex items-center justify-center gap-2 bg-primary-light/20" @click="$emit('click')">
    <span class="text-sm font-normal text-gray-600">⚡ Raccourcis</span>
  </SecondaryButton>
</template>

<script>
import { SecondaryButton } from "@estaly/ui";

export default {
  components: {
    SecondaryButton,
  },
  emits: ["click"],
};
</script>
